(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/favorites/assets/javascripts/models/favorites.js') >= 0) return;  svs.modules.push('/components/sport/favorites/assets/javascripts/models/favorites.js'); 'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function (Backbone, _, svs) {
  svs.sport = svs.sport || {};
  svs.sport.favorites = svs.sport.favorites || {};
  svs.sport.favorites.models = svs.sport.favorites.models || {};
  var log = new svs.core.log.Logger('svs.sport.favorites.models.Favorites');
  svs.sport.favorites.models.Favorites = Backbone.Model.extend({
    url: "".concat(svs.core.jupiter.url(), "/player/favorites"),
    localStorageID: 'svs.sport.favorites.models.Favorites',
    storeTime: 5 * 60 * 1000,
    initialize: function initialize() {
      this.teams = new svs.sport.favorites.collections.FavoriteTeamList();
      this.leagues = new svs.sport.favorites.collections.FavoriteLeagueList();
      this.teamscopy = {};
      this.leaguescopy = {};

      if (this.attributes.teams || this.attributes.leagues) {
        log.debug('Using favorites from initialization.');
        this.parse({
          favorites: this.attributes
        }, {
          hasChanged: true
        });
      } else {
        log.debug('Fetching favorites.');
        this.fetch();
      }
    },
    fetch: function fetch() {
      var alertMessage;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (args.length < 1) {
        args[0] = {};
      } 


      if (!args[0].error) {
        args[0].error = function (model, response, options) {
          var title = 'Vi kunde inte hämta dina favoriter';

          if (response.responseJSON.error.code === 100005) {
            alertMessage = 'Du har blivit utloggad.';
          } else {
            log.error('Failed to fetch Favorites', svs.core.jupiter.parseErrorResponse(options.xhr));
          }

          var dialogConfig = {
            branding: svs.components.dialog.branding.SPORT,
            icon: 'favorites',
            type: svs.components.dialog.type.ERROR,
            title: title,
            actions: [{
              title: 'OK'
            }]
          };

          if (alertMessage) {
            dialogConfig.message = [{
              type: svs.components.dialog.message.TEXT,
              text: alertMessage
            }];
          }

          svs.components.dialog.api.add(new svs.components.dialog.Confirm(dialogConfig));
        };
      }

      this.constructor.__super__.fetch.apply(this, args);
    },
    parse: function parse(response) {
      log.debug('Parsing response.', response);
      var changedFavorites = svs.sport.initFavorites ? svs.sport.initFavorites : false;
      svs.sport.initFavorites = false;
      var favorites = response.favorites;

      if (!favorites) {
        return response;
      }

      this.teams.reset(favorites.teams);
      this.leagues.reset(favorites.leagues);
      this.teamscopy = this.teams.clone();
      this.leaguescopy = this.leagues.clone();

      if (svs.sport.favorites.models.favorites) {
        favorites = svs.sport.favorites.models.favorites;
        svs.sport.favorites.models.favorites.trigger('reset', changedFavorites);
      } else {
        this.trigger('reset', changedFavorites);
      }

      return favorites;
    },
    modify: function modify(data) {
      if (data.type === 'team') {
        this.teams.modify(data);
      } else {
        this.leagues.modify(data);
      }
    },
    save: function save(successCallback, errorCallback) {
      var self = this;
      var options = {
        method: 'PUT',
        path: '/player/favorites',
        data: {
          favorites: {
            teams: this.teams.toSaveData(),
            leagues: this.leagues.toSaveData()
          }
        }
      };
      svs.components.loader.show();

      try {
        svs.core.jupiter.call(options, function (response) {
          log.debug('Saved favorites.', response);
          var _response$favorites = response.favorites,
              teams = _response$favorites.teams,
              leagues = _response$favorites.leagues;
          var teamDiffs = self.getDifferences(teams, self.teamscopy.toJSON(), 'TeamId');
          var leagueDiffs = self.getDifferences(leagues, self.leaguescopy.toJSON(), 'LeagueId');
          var message = self.formatSaveMessage(teamDiffs, leagueDiffs);

          if (message.length) {
            svs.components.dialog.api.add(new svs.components.dialog.Confirm({
              branding: svs.components.dialog.branding.SPORT,
              icon: 'favorites',
              title: 'Dina favoriter har uppdaterats',
              message: [{
                type: svs.components.dialog.message.TEXT,
                text: message
              }],
              actions: [{
                title: 'OK'
              }]
            }));
          }

          var hasChanged = JSON.stringify(self.leaguescopy) !== JSON.stringify(leagues) || JSON.stringify(self.teamscopy) !== JSON.stringify(teams);
          svs.sport.initFavorites = hasChanged;
          self.parse(response);

          if (successCallback) {
            successCallback(hasChanged);
          }

          self.signalChanges(teamDiffs, leagueDiffs);
          svs.components.loader.hide();
        }, function (jqXHR, textStatus, error) {
          svs.components.loader.hide();
          log.error('Failed to save Favorites', svs.core.jupiter.parseErrorResponse(error));
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'favorites',
            title: 'Vi kunde inte spara dina favoriter',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: 'Försök igen.'
            }],
            actions: [{
              title: 'OK'
            }]
          }));

          if (errorCallback) {
            errorCallback();
          }
        });
      } catch (exception) {
        svs.components.loader.hide();
        log.error('Generic error: Failed to save Favorites', svs.core.jupiter.parseErrorResponse(exception));
        svs.components.dialog.api.add(new svs.components.dialog.Confirm({
          branding: svs.components.dialog.branding.SPORT,
          icon: 'favorites',
          title: 'Vi kunde inte spara dina favoriter',
          message: [{
            type: svs.components.dialog.message.TEXT,
            text: 'Försök igen.'
          }],
          actions: [{
            title: 'OK'
          }]
        }));

        if (errorCallback) {
          errorCallback();
        }
      }
    },

    getDifferences: function getDifferences(current, previous, key) {
      var added = _.filter(current, function (obj) {
        return !_.findWhere(previous, _defineProperty({}, key, obj[key]));
      });

      var removed = _.filter(previous, function (obj) {
        return !_.findWhere(current, _defineProperty({}, key, obj[key]));
      });

      return {
        added: added,
        removed: removed
      };
    },
    formatSaveMessage: function formatSaveMessage(teamDiffs, leagueDiffs) {
      var message = '',
          removedMessage = '',
          i;
      var addedTeams = teamDiffs.added,
          removedTeams = teamDiffs.removed,
          addedLeagues = leagueDiffs.added,
          removedLeagues = leagueDiffs.removed;

      if (addedTeams.length + addedLeagues.length > 3 || removedTeams.length + removedLeagues.length > 3) {
        if (addedTeams.length || addedLeagues.length) {
          if (addedTeams.length) {
            message += "".concat(addedTeams.length, " lag").concat(addedLeagues.length ? ' och ' : ' ');
          }

          if (addedLeagues.length) {
            message += addedLeagues.length + (addedLeagues.length > 1 ? ' ligor ' : ' liga ');
          }

          message += 'har lagts till i dina favoriter.';
        }

        if (removedTeams.length || removedLeagues.length) {
          if (message.length > 0) {
            message += '<br><br>';
          }

          if (removedTeams.length) {
            message += "".concat(removedTeams.length, " lag").concat(removedLeagues.length ? ' och ' : ' ');
          }

          if (removedLeagues.length) {
            message += removedLeagues.length + (removedLeagues.length > 1 ? ' ligor ' : ' liga ');
          }

          message += 'har tagits bort från dina favoriter.';
        }

        return message;
      }

      if (!_.isEmpty(addedTeams)) {
        for (i = 0; i < addedTeams.length; i++) {
          message += addedTeams[i].TeamName;

          if (i === addedTeams.length - 1) {
            message += " har lagts till som ".concat(i === 0 ? 'favorit' : 'favoriter');
          } else if (i === addedTeams.length - 2) {
            message += ' och ';
          } else {
            message += ', ';
          }
        }
      }

      if (!_.isEmpty(removedTeams)) {
        removedMessage = '';

        for (i = 0; i < removedTeams.length; i++) {
          removedMessage += removedTeams[i].TeamName;

          if (i === removedTeams.length - 1) {
            removedMessage += ' har tagits bort';
          } else if (i === removedTeams.length - 2) {
            removedMessage += ' och ';
          } else {
            removedMessage += ', ';
          }
        }

        if (addedTeams.length === 0) {
          message += "".concat(removedMessage, " som ").concat(removedTeams.length === 1 ? 'favorit' : 'favoriter');
        } else {
          message += " och ".concat(removedMessage);
        }
      }

      if (!_.isEmpty(addedTeams) || !_.isEmpty(removedTeams)) {
        message += '.';
      }

      if ((!_.isEmpty(addedTeams) || !_.isEmpty(removedTeams)) && (!_.isEmpty(addedLeagues) || !_.isEmpty(removedLeagues))) {
        message += '<br><br>';
      }

      if (!_.isEmpty(addedLeagues)) {
        for (i = 0; i < addedLeagues.length; i++) {
          message += addedLeagues[i].Name;

          if (i === addedLeagues.length - 1) {
            message += " har lagts till som ".concat(i === 0 ? 'favorit' : 'favoriter');
          } else if (i === addedLeagues.length - 2) {
            message += ' och ';
          } else {
            message += ', ';
          }
        }
      }

      if (!_.isEmpty(removedLeagues)) {
        removedMessage = '';

        for (i = 0; i < removedLeagues.length; i++) {
          removedMessage += removedLeagues[i].Name;

          if (i === removedLeagues.length - 1) {
            removedMessage += ' har tagits bort';
          } else if (i === removedLeagues.length - 2) {
            removedMessage += ' och ';
          } else {
            removedMessage += ', ';
          }
        }

        if (addedLeagues.length === 0) {
          message += "".concat(removedMessage, " som ").concat(removedLeagues.length === 1 ? 'favorit' : 'favoriter');
        } else {
          message += " och ".concat(removedMessage);
        }
      }

      if (!_.isEmpty(addedLeagues) || !_.isEmpty(removedLeagues)) {
        message += '.';
      }

      return message;
    },
    signalChanges: function signalChanges(teamDiffs, leagueDiffs) {
      if (teamDiffs.removed.length) {
        this.trigger('teamsRemoved', teamDiffs.removed);
      }

      if (leagueDiffs.removed.length) {
        this.trigger('leaguesRemoved', leagueDiffs.removed);
      }

      if (teamDiffs.added.length) {
        this.trigger('teamsAdded', teamDiffs.added);
      }

      if (leagueDiffs.added.length) {
        this.trigger('leaguesAdded', leagueDiffs.added);
      }
    },

    getTotalNumberOfFavorites: function getTotalNumberOfFavorites() {
      var total = 0;

      if (this.teams && this.teams.length >= 0) {
        total += this.teams.length;
      }

      if (this.leagues && this.leagues.length >= 0) {
        total += this.leagues.length;
      }

      return total;
    }
  });
})(Backbone, _, svs);
 })(window);